/**
 * Share Scorecard With Manager Service
 *
 * Application service that delegates scorecard sharing to the API layer.
 * This keeps feature hooks focused on UI state transitions and orchestration.
 */
import { shareScorecardWithManager } from '@/lib';

/**
 * Input contract for sharing a scorecard.
 */
export interface LoadShareScorecardWithManagerInput {
  /** User id of the person sharing the scorecard. */
  userId: string;
  /** Target scorecard id to share. */
  scoreCardId: number;
  /** The ID of the session associated with the scorecard */
  sessionId: number;
  /** Optional explicit recipient user id; defaults to manager when omitted. */
  shareWithUserId?: number;
}

/**
 * Share a scorecard with the user's manager (or explicit target user).
 *
 * @param input Share request payload.
 * @returns API response from the share endpoint.
 */
export const loadShareScorecardWithManager = async ({
  userId,
  scoreCardId,
  sessionId,
  shareWithUserId,
}: LoadShareScorecardWithManagerInput) => {
  return shareScorecardWithManager({
    scoreCardId,
    sessionId,
    shareWithUserId,
    userId,
  });
};
